/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseslistuntitled2Inputs */

const en_caseslistuntitled2 = /** @type {(inputs: Caseslistuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled case`)
};

const pt_caseslistuntitled2 = /** @type {(inputs: Caseslistuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso sem título`)
};

/**
* | output |
* | --- |
* | "Untitled case" |
*
* @param {Caseslistuntitled2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseslistuntitled2 = /** @type {((inputs?: Caseslistuntitled2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseslistuntitled2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseslistuntitled2(inputs)
	return pt_caseslistuntitled2(inputs)
});
export { caseslistuntitled2 as "casesListUntitled" }